/* globals apiConn */

let React = require('react');

const AlwaysObj = [
  /*
  {
    url: '/campaign/gattinara/',
    img: '/public/img/banners/gattinara309.jpg',
    alt: 'Gattinara'
    },
  */
   {
    url: '/campaign/legrandroi/',
    img: '/public/img/banners/legrandroi309.jpg',
    alt: 'Le Grand Roi'
    },
   {
    url: '/campaign/granvinasol/',
    img: '/public/img/banners/granvina309.jpg',
    alt: 'Gran Vina'
  }
  /*
  {
    url: '/campaign/borgogno/',
    img: '/public/img/banners/borgogno309.jpg',
    alt: 'Borgogno'
  },
  {
    url: '/campaign/las-mulas/',
    img: '/public/img/banners/lasmulas309.jpg',
    alt: 'Las-mulas'
  },
  {
    url: '/campaign/louis-bouillot/',
    img: '/public/img/banners/louisbouillot309.jpg',
    alt: 'Louis-Bouillot'
  }
  */
  /*{
    url: '/campaign/moulin/',
    img: '/public/img/banners/moulin309.jpg',
    alt: 'Moulin'
  },
  {
    url: '/campaign/montini/',
    img: '/public/img/banners/montini309.jpg',
    alt: 'Montini'
  }*/
  /*{
    url: '/campaign/cameleon/',
    img: '/public/img/banners/cameleon309.jpg',
    alt: 'Cameleon'
  }*/
  /*{
    url: '/campaign/bonpas/',
    img: '/public/img/banners/bonpas309.jpg',
    alt: 'Bonpas'
  },*/
  /*{
    url: '/campaign/huntyard/',
    img: '/public/img/banners/huntyard309.jpg',
    alt: 'Huntyard'
  }*/
];

const BannersObj = [
  {
    url: '/campaign/chevalier/',
    img: '/public/img/banners/chevalier309.jpg',
    alt: 'Chevalier'
  },
  {
    url: '/campaign/cigarra/',
    img: '/public/img/banners/cigarra309.jpg',
    alt: 'CIGARRA'
  },
  {
    url: '/campaign/poliziano/',
    img: '/public/img/banners/poliziano309.jpg',
    alt: 'Poliziano'
  },
  /*
  {
    url: '/campaign/perfectday/',
    img: '/public/img/banners/perfectday309.jpg',
    alt: 'Perfect day'
  },
  */
  {
    url: '/campaign/charmes/',
    img: '/public/img/banners/charmes309.jpg',
    alt: 'Charmes'
  },
  /*{
    url: '/campaign/morbergjul/',
    img: '/public/img/banners/morbergjul309.jpg',
    alt: 'Morberg jul'
  },*/
  {
    url: '/campaign/torres/',
    img: '/public/img/banners/torres309.jpg',
    alt: 'TORRES'
  },
  {
    url: '/campaign/grancoronas/',
    img: '/public/img/banners/grancoronas309.jpg',
    alt: 'Gran Coronas'
  },
  {
    url: '/campaign/unpoco/',
    img: '/public/img/banners/unpoco309.jpg',
    alt: 'UN POCO'
  },
  {
    url: '/campaign/stjohn/',
    img: '/public/img/banners/stjohn309.jpg',
    alt: 'St.John'
  },
  {
    url: '/campaign/beau-site/',
    img: '/public/img/banners/beau-site309.jpg',
    alt: 'BEAU-SITE'
  }
];

let BannerItem = React.createClass({
  propTypes: {
    item: React.PropTypes.object
  },

  getInitialState: function () {
    let out = {};

    return out;
  },

  componentWillReceiveProps: function (props) {

  },

  componentDidMount: function () {

  },

  render () {
    return (
      <div>
        <a href={this.props.item.url} target='_blank'>
          <img src={this.props.item.img} alt={this.props.item.alt} />
        </a>
      </div>
    );
  }
});

let BannerList = React.createClass({
  propTypes: {
  },

  getInitialState: function () {
    const bannerData = [];

    for (let a = 0; a < AlwaysObj.length; a++) {
      let item = AlwaysObj[a];
      bannerData.push(item);
    }

    const ar = BannersObj.slice();

    for (let a = 0; a < 0; a++) {
      let index = Math.round(Math.random() * (ar.length - 1));
      let item = ar.splice(index, 1)[0];

      bannerData.push(item);
    }

    var adHeight = { 'skyscraper_ad': '610px' };

    return {bannerData: bannerData, adHeight: adHeight};
  },

  componentDidMount: function () {
    window.resizeSkyAd = this.resizeAdElement;
  },

  componentWillUnmount: function () {
    window.resizeSkyAd = false;
  },

  resizeAdElement: function (id, height) {
    var adHeight = this.state.adHeight;
    adHeight[id] = height;
    this.setState({adHeight: adHeight});
  },

  render () {
    const bannerData = this.state.bannerData;

    const banners = [];

    for (let a = 0; a < bannerData.length; a++) {
      let key = 'banner_' + a;
      banners.push(<BannerItem key={key} item={bannerData[a]} />);
    }

    /*
    var adKey = 'skyscraper_ad';

    var height = this.state.adHeight[adKey];
    const iframeStyle = {};
    iframeStyle['overflow'] = 'hidden';
    iframeStyle['height'] = height + 'px';
    */

    var divStyle = {
    };

    //var iframePath = '/ad_tailsweep.php?type=sky&resize=1&resizeFunc=resizeSkyAd&id=' + adKey;

    return (
      <div style={divStyle} className>
        {banners}
        {/*
        <div>
          <iframe src={iframePath} sandbox='allow-same-origin allow-scripts allow-forms allow-popups' scrolling='no' style={iframeStyle} frameBorder='0'/>
        </div>
        */}
      </div>
    );
  }
});

module.exports = BannerList;



// WEBPACK FOOTER //
// ./src/scripts/components/banners.js